/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Payment_SubmitInputs */

const vi_customer_debt_payment_submit = /** @type {(inputs: Customer_Debt_Payment_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu thu`)
};

/**

* @param {Customer_Debt_Payment_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_payment_submit = /** @type {((inputs?: Customer_Debt_Payment_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Payment_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_payment_submit(inputs)
});